import React, { useState } from "react";
import FolderIcon from "@mui/icons-material/Folder";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Box, Collapse, IconButton, Stack } from "@mui/material";
import { Field, useField } from "formik";
import { FormikAutocomplete } from "./form/FormikAutocomplete";
import Grid from "@mui/material/Grid";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { formatBytes } from "@poseidon/utils/formatBytes";
import { ChipSmall } from "./ChipSmall";
import { TextField } from "formik-mui";
const getFileName = (name, extension, fallback) => {
  if (name) {
    return name + (extension ? "." + extension : "");
  }
  return fallback;
};

export function FileUploadItem({ name, size, index, filePurposes }) {
  const [open, setOpen] = useState(true);
  const [filePurposeField] = useField(`filePurposes[${index}]`);
  const [fileNameField] = useField(`fileNames[${index}]`);
  const [fileExtField] = useField(`fileExtensions[${index}]`);
  const hasFilePurposes = !!Object.entries(filePurposes || {}).length;

  return (
    <>
      <ListItem
        key={index}
        // secondaryAction={
        //   <IconButton
        //     edge="end"
        //     aria-label="more"
        //     onClick={() => setOpen(!open)}
        //   >
        //     {open ? <ExpandLess /> : <ExpandMore />}
        //   </IconButton>
        // }
      >
        <ListItemIcon>
          <FolderIcon />
        </ListItemIcon>
        <Stack>
          <ListItemText
            primary={getFileName(
              fileNameField?.value,
              fileExtField?.value,
              name
            )}
            mt={4}
          />
          <Box>
            {size && <ChipSmall>{formatBytes(size)}</ChipSmall>}
            {filePurposeField?.value && (
              <ChipSmall>{filePurposeField.value.label}</ChipSmall>
            )}
          </Box>
        </Stack>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Grid container spacing={2} my={1} width={1}>
          <Grid
            item
            xs={12}
            sm={hasFilePurposes ? 6 : 12}
            sx={{ display: "flex" }}
          >
            <Field
              component={TextField}
              name={`fileNames[${index}]`}
              label="Name"
              size="small"
              margin="none"
              fullwidth={true}
              placeholder={name}
              sx={{ flex: 1 }}
            />
            <Field
              component={TextField}
              name={`fileExtensions[${index}]`}
              label="Extension"
              size="small"
              margin="none"
              fullwidth={true}
              placeholder={name}
              sx={{ width: 96 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {hasFilePurposes && (
              <Field
                component={FormikAutocomplete}
                label="File Purpose"
                name={`filePurposes[${index}]`}
                options={filePurposes}
                size="small"
                fullwidth={true}
                isOptionEqualToValue={(
                  { label: optionLabel, value: optionValue },
                  { label: selectedLabel, value: selectedValue }
                ) => {
                  if (optionValue === selectedValue) {
                    if (optionLabel !== selectedLabel) {
                      console.error("Label mismatch, check file config");
                      return false;
                    }

                    return true;
                  }

                  return false;
                }}
              />
            )}
          </Grid>
        </Grid>
      </Collapse>
    </>
  );
}
